<template>
	<!-- app bar for standard desktop view -->
	<div v-if="userInfo" class="appHeader">
		<a class="d-sr-only-focusable" href="#mainContent" id="skipToMain">Skip to main content</a>
		<v-app-bar height="110" v-if="$vuetify.breakpoint.mdAndUp">
			<v-toolbar-title class="toolbar-title-navigation" style="margin-left:-35px" @click="$router.push('/landing')" @keyup.enter="$router.push('/landing')" tabindex="0" role="link">
				<img alt="National Institute of Health Automated Self-Administered 24 Hour Dietary Assessment Tool" :src="require('@/assets/NIH-ASA_Logo.png')">
				<span class="d-sr-only">Go to Researcher Site landing page</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-title class="toolbar-title-navigation" height="100" @click="$router.push('/landing')" @keyup.enter="$router.push('/landing')" tabindex="0" role="link">
				<span class="d-sr-only">Or click here to go to</span> Researcher Site <span class="d-sr-only"> landing page</span>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn class="btn-link header-button" v-if="isLoggedIn && isAdmin" text small @click="$router.push('/admin')">
				Admin
			</v-btn>
			<v-divider v-if="isLoggedIn" vertical inset></v-divider>
			<v-btn class="btn-link header-button" v-if="isLoggedIn" text small @click="profileClick">
				Profile
			</v-btn>
			<v-btn class="btn-link header-button" v-else text small @click="bugClick">
				Report a Bug
			</v-btn>
			<v-divider vertical inset></v-divider>
			<v-btn class="btn-link header-button" text small @click="$router.push('/contact')">
				Contact Us
			</v-btn>
			<v-divider vertical inset></v-divider>
			<v-btn class="btn-link header-button" v-if="isLoggedIn" text small @click="logout">
				Logout
			</v-btn>
			<v-btn class="btn-link header-button" v-if="!isLoggedIn" text small @click="login">
				Login
			</v-btn>
		</v-app-bar>
<!-- app bar for small screen-->
		<v-app-bar height="110" v-else-if="$vuetify.breakpoint.sm">
			<div class="appBarSmall">
				<div class="appBarSmallTop">
					<img height="90" alt="National Institute of Health Automated Self-Administered 24 Hour Dietary Assessment Tool" :src="require('@/assets/NIH-ASA_Logo.png')">
					<v-toolbar-title class="toolbar-title-navigation" height="100" style="line-height: 60px; font-size: 20px; margin-right: 35px;" @click="$router.push('/landing')" @keyup.enter="$router.push('/landing')" tabindex="0" role="link">
						<span class="d-sr-only">Or click here to go to</span> Researcher Site <span class="d-sr-only"> landing page</span>
					</v-toolbar-title>
				</div>
				<div class="appBarSmallOptions">
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="isLoggedIn && isAdmin" text @click="$router.push('/admin')">
						Admin
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="isLoggedIn" text @click="profileClick">
						Profile
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-else text @click="bugClick">
						Report a Bug
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" text @click="$router.push('/contact')">
						Contact Us
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="isLoggedIn" text @click="logout">
						Logout
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="!isLoggedIn" text @click="login">
						Login
					</v-btn>
				</div>
			</div>
		</v-app-bar>
		<!-- app bar for mobile screen-->
		<v-app-bar height="110" v-else>
			<div class="appBarSmall">
				<div class="appBarSmallTop">
					<img height="60" alt="National Institute of Health Automated Self-Administered 24 Hour Dietary Assessment Tool" :src="require('@/assets/NIH-ASA_Logo.png')">
					<v-toolbar-title class="toolbar-title-navigation" height="100" style="line-height: 60px; font-size: 12px; margin-right: 35px;" @click="$router.push('/landing')" @keyup.enter="$router.push('/landing')" tabindex="0" role="link">
						<span class="d-sr-only">Or click here to go to</span> Researcher Site <span class="d-sr-only"> landing page</span>
					</v-toolbar-title>
				</div>
				<div class="appBarMobileOptions">
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="isLoggedIn && isAdmin" text @click="$router.push('/admin')">
						Admin
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="isLoggedIn" text @click="profileClick">
						Profile
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-else text @click="bugClick">
						Report a Bug
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" text @click="$router.push('/contact')">
						Contact Us
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="isLoggedIn" text @click="logout">
						Logout
					</v-btn>
					<v-btn height="15" class="btn-link mobile-header-btn" v-if="!isLoggedIn" text @click="login">
						Login
					</v-btn>
				</div>
			</div>
		</v-app-bar>
		<v-app-bar v-if="isImpersonating">
			<v-spacer></v-spacer>
			<v-toolbar-title class="impersonation-title" >
				Impersonating: {{userInfo.email}}
			</v-toolbar-title>
			<v-btn class="btn-default" :loading="isEndImpersonationLoading" text small @click="endImpersonation">Leave</v-btn>
		</v-app-bar>
	</div>
</template>

<script>
import { utilityService } from '@/services/utilityService.js';

export default {
	name: 'AppHeader',
	props: {
	},
	data: () => ({
		profileDialog: false,
		isEndImpersonationLoading: false
	}),
	methods: {
		profileClick () {
			// this.profileDialog = true;
			this.$router.push('/profile')
		},
		contactClick () {
			// $router.push('/landing')
		},
		logout () {
			this.$store.dispatch('logout', { fullClear: true });
		},
		login () {
			if (utilityService.getDisplayLoginForm()) {
				// If we are displaying the login form on the researcher page then bring the user to the local login page
				this.$router.push('/login')
			} else {
				// Otherwise redirect to the root login page
				location.replace(utilityService.getLoginUrl());
			}
		},
		bugClick () {
			this.$router.push('/reportBug')
		},
		endImpersonation () {
			this.isEndImpersonationLoading = true;
			const me = this;
			this.$store.dispatch('endImpersonation').then(function () {
				me.isEndImpersonationLoading = false;
				me.$router.push({ name: 'admin' });
			});
		}
	},
	computed: {
		userInfo: function () {
			return this.$store.getters.getUserInfo;
		},
		tokenClaims: function () {
			return this.$store.getters.getTokenClaims;
		},
		isAdmin: function () {
			return this.$store.getters.isAdmin;
		},
		isLoggedIn: function () {
			return this.$store.getters.isLoggedIn;
		},
		isImpersonating: function () {
			return this.$store.getters.isImpersonating;
		},
		impersonatedUserUuid: function () {
			return this.$store.getters.getImpersonatedUserUuid;
		}
	}
}
</script>

<style>
.divider-vertical {
	max-height:65%;
}
</style>
